export default "__VITE_ASSET__1b2e52b5__"